const TOPICS_DATA = [
  { tag: '#流浪地球3', heat: '128万讨论', color: 'bg-primary-100 text-primary-700' },
  { tag: '#国产科幻崛起', heat: '96万讨论', color: 'bg-accent-100 text-accent-800' },
  { tag: '#诺兰电影全集', heat: '85万讨论', color: 'bg-secondary-100 text-secondary-800' },
  { tag: '#2026暑期档', heat: '73万讨论', color: 'bg-primary-50 text-primary-600' },
  { tag: '#高清免费观影', heat: '68万讨论', color: 'bg-accent-50 text-accent-700' },
  { tag: '#经典电影重温', heat: '54万讨论', color: 'bg-secondary-50 text-secondary-700' },
  { tag: '#动画电影推荐', heat: '47万讨论', color: 'bg-primary-100 text-primary-700' },
  { tag: '#悬疑片推荐', heat: '41万讨论', color: 'bg-accent-100 text-accent-800' },
  { tag: '#免VIP看电影', heat: '35万讨论', color: 'bg-secondary-100 text-secondary-800' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-5xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            全网影迷都在讨论的热门电影话题
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {TOPICS_DATA.map((t) => (
            <a
              key={t.tag}
              href="#topics"
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium ${t.color} hover:opacity-80 transition-opacity duration-200 cursor-pointer`}
            >
              <span>{t.tag}</span>
              <span className="text-xs opacity-70 whitespace-nowrap">{t.heat}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}